<template>
  <div class="oneClickRecycle">
    <div class="header">
      <img :src="recycleBg" alt="" />
    </div>
    <!-- <div class="wechat">
      <div>
        <img :src="qrCode" alt="">
        <p>天府再生资源码上收</p>
      </div>
    </div> -->
    <bottom-url/>
  </div>

</template>
<script>
import BottomUrl from "@/components/bottomUrl/bottomUrl.vue";
import {scrollTop} from "@/util/scrollTop";

export default {
  name: 'oneClickRecycle',
  components: {BottomUrl},
  data() {
    return {
      recycleBg: require('@/assets/recycling/oneClickRecycle/recycleBg.png'),
      qrCode: require('@/assets/recycling/oneClickRecycle/qrCode.png'),
    };
  },
  methods:{
    moveHome(){
      scrollTop()
    }
  }
};
</script>
<style scoped lang="less">
.oneClickRecycle {
  width: 100%;
  background-color: #f4f6f6;
}
.header {
  width: 100%;
  // padding-top: 30px;
  margin: 0 auto;
  // height: 600px;
  img {
    width: 100%;
    height: 100%;
  }
}
.content {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
}
.wechat {
  margin-top: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 60px;
  img {
    width: 200px;
    height: 200px;
  }
  p {
    margin-top: 10px;
    font-size: 18px;
    text-align: center;
  }
}
</style>
